import { createAction, createSlice } from "@reduxjs/toolkit";

const getCartSlice = createSlice({
  name: "getCart",
  initialState: { data: [], processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data.data.filter(
        (item) => item.course !== null
      );
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    updateIsActiveCartItem(state, action) {
      const { id, isActive } = action.payload;
      state.data = state.data.map((item) =>
        item.course.id === id ? { ...item, isActive: isActive } : item
      );
    },
  },
});

const { name, actions, reducer } = getCartSlice;
const getCartAction = createAction(name);
const updateIsActiveCartItemAction = actions.updateIsActiveCartItem;

export {
  getCartAction,
  updateIsActiveCartItemAction,
  actions as getCartActions,
  reducer as getCartReducer,
};
